<template>
  <div>
    <router-view />
  </div>
</template>

<script>
import { socket, connect } from "@/socket";
import { toast } from "vue3-toastify";
import pingSound from "@/assets/audio/ping_sound.mp3";
import { h } from "vue";

export default {
  data() {
    return {
      userId: null,
      audio: null,
      audioUnlocked: false,
    };
  },

  mounted() {
    // Create reusable audio instance
    this.audio = new Audio(pingSound);

    // Unlock audio after first user interaction (browser policy)
    window.addEventListener(
      "click",
      () => {
        this.audioUnlocked = true;
      },
      { once: true }
    );

    // Get user from store
    const storedUserId = this.$store?.state?.user?.id;

    if (storedUserId) {
      this.userId = storedUserId;

      // Connect socket
      connect(this.userId);

      // Prevent duplicate listeners
      socket.off("ping");
      socket.off("connect");
      socket.off("disconnect");

      // Global listener for pings
      socket.on("ping", (data) => {
        toast.success(
          () =>
            h(
              "div",
              {
                class:
                  "flex items-start gap-3 p-1",
              },
              [
                // icon indicator
                h(
                  "div",
                  {
                    class:
                      "w-2 h-2 mt-2 rounded-full bg-green-500 flex-shrink-0",
                  }
                ),

                // content
                h("div", { class: "flex flex-col gap-2 flex-1" }, [
                  // title/message
                  h(
                    "div",
                    {
                      class:
                        "text-sm font-medium text-gray-800 leading-snug",
                    },
                    data.message
                  ),

                  // action button row
                  h(
                    "div",
                    { class: "flex items-center justify-start" },
                    [
                      h(
                        "button",
                        {
                          class:
                            "inline-flex items-center gap-1 px-3 py-1.5 text-xs font-medium text-white bg-green-600 rounded-md shadow-sm hover:bg-green-700 active:scale-[0.98] transition-all duration-150",
                          onClick: (e) => {
                            e.stopPropagation();

                            if (!data.route) return;

                            if (data.route.name) {
                              this.$router.push({
                                name: data.route.name,
                                query: data.route.query || {},
                                params: data.route.params || {},
                              });
                            }
                          },
                        },
                        "View details"
                      ),
                    ]
                  ),
                ]),
              ]
            ),
          {
            autoClose: 15000,
            closeOnClick: false,
            closeButton: true,
            hideProgressBar: false,
            position: "top-right",
            pauseOnHover: true,
            draggable: false,
            className:
              "shadow-lg border border-gray-100 rounded-lg bg-white",
          }
        );

        this.playPingSound();
      });

      // Handle reconnect automatically
      socket.on("connect", () => {
        console.log("Socket connected:", socket.id);

        if (this.userId) {
          socket.emit("join", this.userId);
          console.log("Re-joined room for user:", this.userId);
        }
      });

      // Optional: handle disconnect
      socket.on("disconnect", (reason) => {
        console.warn("Socket disconnected:", reason);
      });
    }
  },

  methods: {
    playPingSound() {
      if (!this.audioUnlocked || !this.audio) return;

      try {
        this.audio.currentTime = 0;
        this.audio.play().catch(() => {});
      } catch (error) {
        console.warn("Audio play failed:", error);
      }
    },
  },
};
</script>

<style></style>

